export default "__VITE_ASSET__Cv5LkMwn__"